// src/actions/constants.ts
var PARAM_KEY = "actions", ADDON_ID = "storybook/actions", PANEL_ID = `${ADDON_ID}/panel`, EVENT_ID = `${ADDON_ID}/action-event`, CLEAR_ID = `${ADDON_ID}/action-clear`, CYCLIC_KEY = "$___storybook.isCyclic";

export {
  PARAM_KEY,
  ADDON_ID,
  PANEL_ID,
  EVENT_ID,
  CLEAR_ID,
  CYCLIC_KEY
};
